import _sfc_main from "/Users/pingfanh/project/brawl_mini/brawl-mini-website-mobile/src/news/index.vue?vue&type=script&setup=true&lang.ts";
export * from "/Users/pingfanh/project/brawl_mini/brawl-mini-website-mobile/src/news/index.vue?vue&type=script&setup=true&lang.ts";
import "/Users/pingfanh/project/brawl_mini/brawl-mini-website-mobile/src/news/index.vue?vue&type=style&index=0&scoped=5223165d&lang.scss";
import _export_sfc from "\0plugin-vue:export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-5223165d"]]);
